module.exports = __webpack_public_path__ + "img/duoyun.d1c6256d.png";